import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceDetail from './components/ServiceDetail';
import CTASection from '../home/components/CTASection';
import { useSEO } from '../../utils/seo';

const ServicesPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  useSEO({
    title: 'Hizmetlerimiz - Sigorta360 | Sosyal Medya, Web Tasarım, CRM, Dijital Reklamcılık',
    description: 'Sigorta acenteleri için sosyal medya yönetimi, Google Ads, web tasarımı, CRM entegrasyonu, marka kimliği ve video prodüksiyon hizmetleri. Dijital dönüşümünüzü tamamlayın.',
    keywords: 'sigorta sosyal medya, sigorta web tasarım, sigorta CRM, sigorta Google Ads, sigorta dijital reklam, sigorta marka kimliği',
    canonical: `${siteUrl}/hizmetler`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Dijital Pazarlama ve Teknoloji Çözümleri',
      provider: {
        '@type': 'Organization',
        name: 'Sigorta360',
        url: siteUrl
      },
      areaServed: {
        '@type': 'Country',
        name: 'Türkiye'
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Dijital Hizmetler',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Sosyal Medya Yönetimi',
              description: 'Sigorta sektörüne özel içerik stratejisi ve topluluk yönetimi'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Meta & Google Ads Yönetimi',
              description: 'Hedef kitleye özel kampanyalarla lead maliyetlerini düşürme'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Web Sitesi & Landing Page',
              description: 'CRM entegrasyonlu, dönüşüm odaklı web siteleri'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Marka Kimliği & Tasarım',
              description: 'Güven veren, profesyonel kurumsal kimlik tasarımları'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'CRM & Otomasyon',
              description: 'Poliçe formlarından WhatsApp entegrasyonuna kadar otomasyon'
            }
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Prodüksiyon & Motion Graphics',
              description: 'Güven veren video içerikler ve motion graphics'
            }
          }
        ]
      }
    }
  });

  const services = [
    {
      id: 1,
      category: 'Sosyal Medya',
      title: 'Sosyal Medya Yönetimi',
      description: 'Sigorta sektörüne özel içerik stratejisi ve topluluk yönetimi ile markanızı güçlendiriyoruz.',
      features: [
        'Sigorta odaklı içerik planlaması ve üretimi',
        'Günlük paylaşım ve etkileşim yönetimi',
        'Topluluk yönetimi ve müşteri iletişimi',
        'Performans raporlama ve analiz',
      ],
      image: 'https://public.readdy.ai/ai/img_res/da7826bdfc7fb68f9ef169843a8c450c.jpg',
      reverse: false,
    },
    {
      id: 2,
      category: 'Dijital Reklamcılık',
      title: 'Meta & Google Ads Yönetimi',
      description: 'Hedef kitleye özel kampanyalarla lead maliyetlerinizi düşürüyor, dönüşüm oranlarınızı artırıyoruz.',
      features: [
        'Hedef kitle analizi ve segmentasyon',
        'Kampanya stratejisi ve optimizasyon',
        'A/B test yönetimi ve performans takibi',
        'ROI odaklı bütçe yönetimi',
      ],
      image: 'https://readdy.ai/api/search-image?query=Digital%20advertising%20dashboard%20showing%20Google%20Ads%20and%20Meta%20Ads%20campaign%20performance%2C%20insurance%20industry%20metrics%2C%20conversion%20tracking%2C%20ROI%20analytics%2C%20professional%20marketing%20interface%2C%20blue%20and%20cyan%20color%20scheme%2C%20modern%20business%20software%2C%20data%20visualization%20charts&width=800&height=600&seq=service-ads-001&orientation=landscape',
      reverse: true,
    },
    {
      id: 3,
      category: 'Web Geliştirme',
      title: 'Web Sitesi & Landing Page',
      description: 'CRM entegrasyonlu, dönüşüm odaklı web siteleri ve landing page tasarımları geliştiriyoruz.',
      features: [
        'Responsive ve modern web tasarımı',
        'CRM ve teklif formu entegrasyonu',
        'SEO optimizasyonu ve hız iyileştirme',
        'Kullanıcı deneyimi (UX) odaklı tasarım',
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20insurance%20agency%20website%20design%20mockup%20on%20laptop%20screen%2C%20professional%20landing%20page%20layout%2C%20clean%20UI%20interface%2C%20blue%20corporate%20colors%2C%20responsive%20web%20design%2C%20insurance%20quote%20form%2C%20premium%20business%20aesthetic%2C%20contemporary%20digital%20design&width=800&height=600&seq=service-web-001&orientation=landscape',
      reverse: false,
    },
    {
      id: 4,
      category: 'Marka Tasarımı',
      title: 'Marka Kimliği & Tasarım',
      description: 'Güven veren, profesyonel kurumsal kimlik tasarımları ile markanızı öne çıkarıyoruz.',
      features: [
        'Logo ve kurumsal kimlik tasarımı',
        'Kartvizit, antetli kağıt ve matbaa ürünleri',
        'Sosyal medya görselleri ve şablonlar',
        'Marka rehberi ve kullanım kılavuzu',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20brand%20identity%20design%20showcase%20for%20insurance%20agency%2C%20logo%20variations%2C%20business%20card%20mockups%2C%20corporate%20stationery%2C%20brand%20guidelines%2C%20blue%20and%20gold%20color%20palette%2C%20premium%20business%20branding%2C%20clean%20modern%20design%20aesthetic&width=800&height=600&seq=service-brand-001&orientation=landscape',
      reverse: true,
    },
    {
      id: 5,
      category: 'Teknoloji',
      title: 'CRM & Otomasyon',
      description: 'Poliçe formlarından WhatsApp entegrasyonuna kadar tüm süreçlerinizi otomatikleştiriyoruz.',
      features: [
        'CRM sistemi kurulumu ve entegrasyonu',
        'WhatsApp Business API entegrasyonu',
        'Otomatik bildirim ve hatırlatma sistemleri',
        'Müşteri takip ve raporlama paneli',
      ],
      image: 'https://readdy.ai/api/search-image?query=CRM%20automation%20dashboard%20for%20insurance%20agency%20showing%20customer%20pipeline%2C%20policy%20tracking%2C%20WhatsApp%20integration%2C%20automated%20workflow%20system%2C%20modern%20business%20software%20interface%2C%20blue%20corporate%20colors%2C%20data%20management%20tools%2C%20professional%20technology%20solution&width=800&height=600&seq=service-crm-001&orientation=landscape',
      reverse: false,
    },
    {
      id: 6,
      category: 'İçerik Üretimi',
      title: 'Prodüksiyon & Motion Graphics',
      description: 'Güven veren video içerikler ve motion graphics ile müşterilerinize ulaşın.',
      features: [
        'Kurumsal tanıtım videoları',
        'Ürün ve hizmet tanıtım içerikleri',
        'Motion graphics ve animasyon',
        'Sosyal medya video içerikleri',
      ],
      image: 'https://readdy.ai/api/search-image?query=Video%20production%20studio%20setup%20for%20corporate%20content%20creation%2C%20professional%20camera%20equipment%2C%20lighting%20setup%2C%20insurance%20agency%20promotional%20video%20filming%2C%20modern%20production%20environment%2C%20blue%20themed%20corporate%20video%2C%20professional%20content%20creation%20workspace&width=800&height=600&seq=service-video-001&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-platinum">
      <Header />
      <main>
        <ServicesHero />
        <section className="py-24">
          <div className="max-w-[1440px] mx-auto px-8">
            {services.map((service, index) => (
              <div key={service.id}>
                <ServiceDetail service={service} />
                {index < services.length - 1 && (
                  <div className="my-32 border-t border-gray-200"></div>
                )}
              </div>
            ))}
          </div>
        </section>
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;